export default __webpack_public_path__ + "static/media/club1.652757f6.webp";